import { DataBean } from "../../DataBean";


export class SheetType extends DataBean {

    public async getSocialSecuritySpreadSheetTypeConstants(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSocialSecuritySpreadSheetTypeConstants_Number", [args]);
    }

}